import { z } from 'zod';
import { projectStatusEnum, projectPriorityEnum } from './enums.ts';

export const createProjectInput = z.object({
  domainId: z.string().nullable().optional(),
  zoneId: z.string().nullable().optional(),
  title: z.string().min(1).max(200),
  description: z.string().max(20_000).nullable().optional(),
  status: projectStatusEnum.optional(),
  priority: projectPriorityEnum.optional(),
  startedAt: z.string().nullable().optional(),
  completedAt: z.string().nullable().optional(),
});
export type CreateProjectInput = z.infer<typeof createProjectInput>;

export const patchProjectInput = createProjectInput.partial();
export type PatchProjectInput = z.infer<typeof patchProjectInput>;
